<!-- SwipFx Orders Page - Filterable Order Book (Bootstrap 5) -->
<!-- Tabs need bootstrap.bundle.js -->
<div class="min-vh-100 bg-light">

    <app-header [page]="'Accounts'"></app-header>
    <main class="container py-4">

  <div class="d-flex justify-content-between align-items-center mb-4">
    <div>
      <h4 class="fw-bold mb-0">Compliance Dashboard</h4>
      <div class="text-muted small">Manage your verification status and applications</div>
    </div>

    <div class="d-flex gap-2">
      <button class="btn btn-outline-secondary btn-sm" (click)="load()">
        Refresh
      </button>

      <button class="btn btn-primary btn-sm"
              (click)="startApplication()"
              [disabled]="starting || !canStartNew()">
        <span *ngIf="starting" class="spinner-border spinner-border-sm me-2"></span>
        Start Application
      </button>
    </div>
  </div>

  <div *ngIf="loading" class="text-center py-5">
    <div class="spinner-border"></div>
  </div>

  <div *ngIf="error" class="alert alert-danger">
    {{ error }}
  </div>

  <ng-container *ngIf="!loading && bootstrap as data">

    <div class="row g-4 mb-4">
      <div class="col-md-4">
        <div class="card shadow-sm border-0 h-100">
          <div class="card-body">
            <div class="text-muted small">Country</div>
            <div class="fw-bold fs-5">{{ data.jurisdictionCode }}</div>
            <div class="small text-muted mt-2">
              Verification is managed per country.
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card shadow-sm border-0 h-100">
          <div class="card-body">
            <div class="text-muted small">Current Tier</div>
            <div class="fw-bold fs-5">{{ data.tierCode }}</div>
            <div class="small text-muted mt-2">
              {{ data.customerType }} · {{ data.productType }}
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card shadow-sm border-0 h-100">
          <div class="card-body">
            <div class="text-muted small">Latest Application</div>

            <div *ngIf="latestApplication; else noLatest">
              <span class="badge" [ngClass]="getStatusClass(latestApplication.status)">
                {{ latestApplication.status }}
              </span>
              <div class="small text-muted mt-2">
                Started {{ latestApplication.startedAt | date:'medium' }}
              </div>
            </div>

            <ng-template #noLatest>
              <div class="fw-semibold">No application yet</div>
              <div class="small text-muted mt-2">
                Start your first verification application.
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>

    <div class="card shadow-sm border-0 mb-4" *ngIf="latestApplication">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-start flex-wrap gap-3">
          <div>
            <h5 class="mb-1">Latest Application</h5>
            <div class="text-muted small">
              {{ latestApplication.jurisdictionCode }} · {{ latestApplication.tierCode }} · {{ latestApplication.productType }}
            </div>
          </div>

          <span class="badge" [ngClass]="getStatusClass(latestApplication.status)">
            {{ latestApplication.status }}
          </span>
        </div>

        <div class="row g-3 mt-2">
          <div class="col-md-3">
            <div class="text-muted small">Started</div>
            <div class="fw-semibold">{{ latestApplication.startedAt | date:'medium' }}</div>
          </div>

          <div class="col-md-3" *ngIf="latestApplication.submittedAt">
            <div class="text-muted small">Submitted</div>
            <div class="fw-semibold">{{ latestApplication.submittedAt | date:'medium' }}</div>
          </div>

          <div class="col-md-3" *ngIf="latestApplication.approvedAt">
            <div class="text-muted small">Approved</div>
            <div class="fw-semibold">{{ latestApplication.approvedAt | date:'medium' }}</div>
          </div>

          <div class="col-md-3" *ngIf="latestApplication.rejectedAt">
            <div class="text-muted small">Rejected</div>
            <div class="fw-semibold">{{ latestApplication.rejectedAt | date:'medium' }}</div>
          </div>
        </div>

        <div *ngIf="latestApplication.reviewNotes" class="alert alert-warning mt-3 mb-0">
          <strong>Review notes:</strong> {{ latestApplication.reviewNotes }}
        </div>

        <div class="d-flex gap-2 flex-wrap mt-4">
          <button class="btn btn-outline-primary btn-sm" (click)="openLatest()">
            View Details
          </button>

          <button *ngIf="canContinue()"
                  class="btn btn-primary btn-sm"
                  (click)="continueApplication()">
            Continue Application
          </button>
        </div>
      </div>
    </div>

    <div class="row g-4">
      <div class="col-md-6">
        <div class="card shadow-sm border-0 h-100">
          <div class="card-body">
            <h5 class="mb-2">Applications</h5>
            <p class="text-muted small">
              View all your KYC applications, statuses, and review outcomes.
            </p>

            <button class="btn btn-outline-secondary btn-sm" (click)="openApplications()">
              View Applications
            </button>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card shadow-sm border-0 h-100">
          <div class="card-body">
            <h5 class="mb-2">Tier Limits</h5>
            <p class="text-muted small">
              View your available compliance tier table and permitted limits.
            </p>

            <button class="btn btn-outline-secondary btn-sm" (click)="openTierTable()">
              View Tier Table
            </button>
          </div>
        </div>
      </div>
    </div>
    <app-support-context-card
      type="compliance"
      title="Need help with verification?"
      subtitle="Get quick answers about KYC, restrictions, and compliance review.">
    </app-support-context-card>
  </ng-container>
<app-footer></app-footer>
    </main>
</div>